/* eslint-disable */
export default {
  _pixel_art_select_sound: 'pixel_art_select_sound',
}